<div class="attachments">
  <ng-template
    *ngIf="(modeData.currentMode$ | async).edit; then editMode; else viewMode"></ng-template>

  <ng-template #editMode>
    <button
      *ngIf="allAttachments?.length"
      mat-button
      class="show-attachments"
      [matTooltip]="'HINTS.SHOW_ATTACHMENTS' | translate"
      [matTooltipPosition]="'above'"
      [ngClass]="{'paperclip-icon': infoStyle?.icon === 'icon-paperclip'}"
      [ngStyle]="{
        'background-color': infoStyle?.backgroundColor,
        'border-radius': infoStyle?.squared ? '' : '50%'
      }"
      (click)="openAttachments()">
      <mat-icon [ngStyle]="{color: infoStyle?.iconColor}" [svgIcon]="infoStyle?.icon"></mat-icon>
    </button>
  </ng-template>

  <ng-template #viewMode>
    <button
      *ngIf="allAttachments?.length"
      mat-button
      class="show-attachments"
      [matTooltip]="'HINTS.SHOW_ATTACHMENTS' | translate"
      [matTooltipPosition]="'above'"
      [matTooltipDisabled]="attachmentsOpened"
      [matMenuTriggerFor]="attachmentsMenu"
      [ngClass]="{'paperclip-icon': infoStyle?.icon === 'icon-paperclip'}"
      [ngStyle]="{
        'background-color': infoStyle?.backgroundColor,
        'border-radius': infoStyle?.squared ? '' : '50%'
      }"
      (click)="openMenu()">
      <mat-icon [ngStyle]="{color: infoStyle?.iconColor}" [svgIcon]="infoStyle?.icon"></mat-icon>
    </button>
  </ng-template>

  <mat-menu
    #attachmentsMenu="matMenu"
    (closed)="onMenuClose()"
    overlapTrigger="true"
    class="paperclip">
    <div
      *ngFor="
        let item of allAttachments | userGroupsFilter: userGroups : isProSpace;
        trackBy: track
      ">
      <button mat-menu-item [disableRipple]="true" (click)="openSingleAttachment(item)">
        <mat-icon
          class="paperclip__icon"
          [svgIcon]="item | transform: getAttachmentIcon"
          [ngClass]="{'without-stroke-width': item?.refModel}"></mat-icon>

        <div class="dt-records-counter" *ngIf="item.dtRecordsCount > -1">
          <span class="dt-records-inner">{{ item.dtRecordsCount | number }}</span>
        </div>

        <div *ngIf="item?.storyId || item?.reqId">
          {{ (item?.storyId || item?.reqId) + ':' }}&nbsp;
        </div>

        <span
          class="paperclip__title"
          [matTooltip]="item.title | decodeHtml"
          [matTooltipPosition]="'right'"
          [matTooltipDisabled]="item.title.length < 22">
          {{ (item?.reqId || item?.storyId ? item.summary : item.title) | decodeHtml }}
        </span>
      </button>
    </div>
  </mat-menu>
</div>
